<div class="transfer-status-panel" [class.monitor]="isMonitorMode">
  <nz-row [nzGutter]="[16, 16]">
    <!-- PENDENTES -->
    <nz-col nzSpan="24" nzMd="12">
      <div class="status-card pending">
        <div class="status-card-header">
          <div class="title">
            <span class="dot dot-orange"></span>
            <h3>Pendentes</h3>
            <span class="count count-orange">{{ pending.length }}</span>
          </div>
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="loadData()"
            nz-tooltip
            nzTooltipTitle="Recarregar">
            <i nz-icon nzType="reload"></i>
          </button>
        </div>

        <div class="search-row">
          <nz-input-group [nzSuffix]="searchPendingIcon">
            <input
              type="text"
              nz-input
              placeholder="Buscar chassi, rota..."
              [(ngModel)]="searchPending"
              (ngModelChange)="applyFilters()" />
          </nz-input-group>
          <ng-template #searchPendingIcon><i nz-icon nzType="search"></i></ng-template>
        </div>

        <div class="status-list" [class.monitor-list]="isMonitorMode">
          <ng-container *ngIf="displayPending.length > 0; else emptyPending">
            <div class="status-item pending-item" *ngFor="let item of displayPending">
              <div class="row-top">
                <div class="plate">
                  <span class="plate-text">{{ item.chassis }}</span>
                  <span
                    *ngIf="item.productName"
                    class="product-name"
                    nz-tooltip
                    [nzTooltipTitle]="item.productName">
                    {{ item.productName }}
                  </span>
                </div>
                <div class="row-actions">
                  <nz-tag nzColor="warning" class="status-tag">
                    <i nz-icon nzType="clock-circle"></i> Pendente
                  </nz-tag>
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    [routerLink]="['/checklist-headers', item.sentChecklistId]"
                    nz-tooltip
                    nzTooltipTitle="Ver detalhes">
                    <i nz-icon nzType="eye"></i>
                  </button>
                </div>
              </div>
              <div class="row-bottom">
                <span class="route-info">
                  <b>Rota:</b> {{ item.origin }}
                  <i nz-icon nzType="arrow-right" class="route-arrow"></i>
                  {{ item.destination }}
                </span>
                <span>
                  <b>Envio:</b> {{ item.sentDate | date: 'dd/MM/yyyy' }}
                </span>
                <span>
                  <b>Recebimento:</b> -
                </span>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyPending>
            <nz-empty
              [nzNotFoundContent]="'Nenhuma transferência pendente'"
              nzNotFoundImage="simple"></nz-empty>
          </ng-template>
        </div>
      </div>
    </nz-col>

    <!-- RECEBIDOS -->
    <nz-col nzSpan="24" nzMd="12">
      <div class="status-card received">
        <div class="status-card-header">
          <div class="title">
            <span class="dot dot-green"></span>
            <h3>Recebidos</h3>
            <span class="count count-green">{{ received.length }}</span>
          </div>
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="loadData()"
            nz-tooltip
            nzTooltipTitle="Recarregar">
            <i nz-icon nzType="reload"></i>
          </button>
        </div>

        <div class="search-row">
          <nz-input-group [nzSuffix]="searchReceivedIcon">
            <input
              type="text"
              nz-input
              placeholder="Buscar chassi, rota..."
              [(ngModel)]="searchReceived"
              (ngModelChange)="applyFilters()" />
          </nz-input-group>
          <ng-template #searchReceivedIcon><i nz-icon nzType="search"></i></ng-template>
        </div>

        <div class="status-list" [class.monitor-list]="isMonitorMode">
          <ng-container *ngIf="displayReceived.length > 0; else emptyReceived">
            <div class="status-item received-item" *ngFor="let item of displayReceived">
              <div class="row-top">
                <div class="plate">
                  <span class="plate-text">{{ item.chassis }}</span>
                  <span
                    *ngIf="item.productName"
                    class="product-name"
                    nz-tooltip
                    [nzTooltipTitle]="item.productName">
                    {{ item.productName }}
                  </span>
                </div>
                <div class="row-actions">
                  <nz-tag nzColor="success" class="status-tag">
                    <i nz-icon nzType="check-circle"></i> Recebido
                  </nz-tag>
                  <button
                    nz-button
                    nzType="text"
                    nzSize="small"
                    [routerLink]="['/checklist-headers', item.sentChecklistId]"
                    nz-tooltip
                    nzTooltipTitle="Ver detalhes">
                    <i nz-icon nzType="eye"></i>
                  </button>
                </div>
              </div>
              <div class="row-bottom">
                <span class="route-info">
                  <b>Rota:</b> {{ item.origin }}
                  <i nz-icon nzType="arrow-right" class="route-arrow"></i>
                  {{ item.destination }}
                </span>
                <span>
                  <b>Envio:</b> {{ item.sentDate | date: 'dd/MM/yyyy' }}
                </span>
                <span>
                  <b>Recebimento:</b>
                  {{ item.receivedDate ? (item.receivedDate | date: 'dd/MM/yyyy') : '-' }}
                </span>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyReceived>
            <nz-empty
              [nzNotFoundContent]="'Nenhuma transferência recebida'"
              nzNotFoundImage="simple"></nz-empty>
          </ng-template>
        </div>
      </div>
    </nz-col>
  </nz-row>
</div>
